module.exports = {"data":{"site":{"siteMetadata":{"title":"Daresay News"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 112
// module chunks = 60335399758886 114276838955818